<div class="dialog-header">
  <h2 mat-dialog-title>
    {{
      (isEdit
        ? 'epd.functions.careplan-nnn.add-row-dialog.edit-title'
        : 'epd.functions.careplan-nnn.add-row-dialog.title'
      )
        | translate
        | capitalize
    }}
  </h2>
  <button
    type="button"
    class="dialog-header__anamnesis-toggle"
    [attr.aria-expanded]="anamnesisOpen()"
    (click)="toggleAnamnesis()">
    <mat-icon>{{ anamnesisOpen() ? 'visibility_off' : 'visibility' }}</mat-icon>
    <span>{{ anamnesisToggleLabel() | translate | capitalize }}</span>
    <mat-icon>{{ anamnesisOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>
</div>
<mat-dialog-content class="add-nnn-dialog" [class.add-nnn-dialog--edit]="isEdit">
  <div class="picker-pane">
    @if (!isEdit) {
      <mat-form-field appearance="outline" class="picker-pane__search" [subscriptSizing]="'dynamic'">
        <input
          matInput
          type="text"
          cdkFocusInitial
          [value]="searchText()"
          (input)="onSearchInput($event)"
          placeholder="{{ 'epd.functions.careplan-nnn.add-row-dialog.search-placeholder' | translate | capitalize }}" />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>

      <div class="progress-slot">
        @if (loading()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </div>
    }

    <div class="results">
      @if (!isEdit) {
        <div class="picker-pane__browser">
          @if (searchActive()) {
            <ul class="item-list">
              @for (diagnose of filteredDiagnoses(); track diagnose.code) {
                <li>
                  <button
                    type="button"
                    class="item-list__item"
                    [class.item-list__item--selected]="diagnose.code === selected()?.code"
                    (click)="select(diagnose)">
                    <span class="item-list__code">{{ diagnose.code }}</span>
                    <span class="item-list__label">{{ diagnose.omschrijving }}</span>
                  </button>
                </li>
              } @empty {
                @if (!loading()) {
                  <li class="item-list__empty">
                    {{ 'epd.functions.careplan-nnn.add-row-dialog.no-results' | translate | capitalize }}
                  </li>
                }
              }
            </ul>
          } @else {
            <mat-accordion class="picker-pane__domeinen">
              @for (domein of tree(); track domein.key) {
                <mat-expansion-panel
                  class="tree-panel tree-panel--domein"
                  [expanded]="isDomeinExpanded(domein.key)"
                  (opened)="setDomeinExpanded(domein.key, true)"
                  (closed)="setDomeinExpanded(domein.key, false)">
                  <mat-expansion-panel-header class="tree-panel__header">
                    <mat-panel-title class="tree-panel__title">
                      <span class="tree-panel__code">{{ domein.label }}</span>
                      <span class="tree-panel__label" [matTooltip]="domein.omschrijving" matTooltipClass="card-tooltip">
                        {{ domein.omschrijving }}
                      </span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @if (domein.definitie) {
                    <p class="tree-panel__definitie">{{ domein.definitie }}</p>
                  }
                  <mat-accordion class="picker-pane__klassen">
                    @for (klasse of domein.klassen; track klasse.key) {
                      <mat-expansion-panel
                        class="tree-panel tree-panel--klasse"
                        [expanded]="isKlasseExpanded(klasse.key)"
                        (opened)="setKlasseExpanded(klasse.key, true)"
                        (closed)="setKlasseExpanded(klasse.key, false)">
                        <mat-expansion-panel-header class="tree-panel__header">
                          <mat-panel-title class="tree-panel__title">
                            <span class="tree-panel__code">{{ klasse.label }}</span>
                            <span
                              class="tree-panel__label"
                              [matTooltip]="klasse.omschrijving"
                              matTooltipClass="card-tooltip">
                              {{ klasse.omschrijving }}
                            </span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @if (klasse.definitie) {
                          <p class="tree-panel__definitie">{{ klasse.definitie }}</p>
                        }
                        <ul class="item-list">
                          @for (diagnose of klasse.diagnoses; track diagnose.code) {
                            <li>
                              <button
                                type="button"
                                class="item-list__item"
                                [class.item-list__item--selected]="diagnose.code === selected()?.code"
                                (click)="select(diagnose)">
                                <span class="item-list__code">{{ diagnose.code }}</span>
                                <span class="item-list__label">{{ diagnose.omschrijving }}</span>
                              </button>
                            </li>
                          } @empty {
                            <li class="item-list__empty">
                              {{ 'epd.functions.careplan-nnn.add-row-dialog.no-results' | translate | capitalize }}
                            </li>
                          }
                        </ul>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </mat-expansion-panel>
              }
            </mat-accordion>
          }
        </div>
      }
      @if (selected(); as chosen) {
        <aside class="detail-panel" [class.detail-panel--full]="isEdit">
          <h3 class="detail-panel__title">
            <span class="detail-panel__code">{{ chosen.code }}</span>
            {{ chosen.omschrijving }}
          </h3>
          @if (detail(); as diagnoseDetail) {
            <p class="detail-panel__definition">{{ diagnoseDetail.definitie }}</p>
            <dl class="detail-panel__facts">
              @if (diagnoseDetail.domeinNaam) {
                <dt>{{ 'epd.functions.careplan-nnn.add-row-dialog.domain' | translate | capitalize }}</dt>
                <dd>{{ diagnoseDetail.domeinNummer }}. {{ diagnoseDetail.domeinNaam }}</dd>
              }
              @if (diagnoseDetail.klasseNaam) {
                <dt>{{ 'epd.functions.careplan-nnn.add-row-dialog.class' | translate | capitalize }}</dt>
                <dd>{{ diagnoseDetail.klasseNummer }}. {{ diagnoseDetail.klasseNaam }}</dd>
              }
              @if (diagnoseDetail.focus) {
                <dt>{{ 'epd.functions.careplan-nnn.add-row-dialog.focus' | translate | capitalize }}</dt>
                <dd>{{ diagnoseDetail.focus }}</dd>
              }
            </dl>
          }
          @if (kenmerkenLoading()) {
            <mat-spinner [diameter]="24"></mat-spinner>
          } @else if (kenmerkenLoadFailed()) {
            <p class="detail-panel__error">
              {{ 'epd.functions.careplan-nnn.add-row-dialog.kenmerken-load-failed' | translate | capitalize }}
            </p>
          } @else if (kenmerken()) {
            @if (hasSelectableKenmerken()) {
              <p class="detail-panel__hint">
                {{ 'epd.functions.careplan-nnn.add-row-dialog.kenmerken-hint' | translate | capitalize }}
              </p>
            }
            @for (sectie of kenmerkSecties(); track sectie.type) {
              <section class="detail-panel__section">
                <h4 class="detail-panel__section-title">
                  {{ 'epd.functions.careplan-nnn.knowledge-base.' + sectie.titleKey | translate | capitalize }}
                </h4>
                @for (groep of sectie.groepen; track groep.categorie) {
                  @if (groep.categorie) {
                    <h5 class="detail-panel__subtitle">{{ groep.categorie }}</h5>
                  }
                  <ul class="check-list">
                    @for (kenmerk of groep.kenmerken; track kenmerk.code) {
                      <li class="check-list__item" [class.check-list__item--selected]="isChecked(sectie.type, kenmerk)">
                        <mat-checkbox
                          color="primary"
                          [checked]="isChecked(sectie.type, kenmerk)"
                          (change)="toggleKenmerk(sectie.type, kenmerk)">
                          {{ kenmerk.omschrijving }}
                          @if (kenmerk.type) {
                            <span class="check-list__hint">{{ kenmerk.type }}</span>
                          }
                          @if (kenmerk.isActive === false) {
                            <span class="check-list__inactive">
                              {{ 'epd.functions.careplan-nnn.add-row-dialog.inactive' | translate }}
                            </span>
                          }
                        </mat-checkbox>
                      </li>
                    }
                  </ul>
                } @empty {
                  <p class="detail-panel__none">
                    {{ 'epd.functions.careplan-nnn.knowledge-base.none' | translate | capitalize }}
                  </p>
                }
              </section>
            }
          }
        </aside>
      }
    </div>
  </div>

  @if (anamnesisOpen()) {
    <section class="anamnesis-overlay">
      <mat-form-field appearance="outline" class="anamnesis-overlay__form-select" [subscriptSizing]="'dynamic'">
        <mat-label>{{ 'epd.functions.careplan-nnn.add-row-dialog.select-form' | translate | capitalize }}</mat-label>
        <mat-select [value]="selectedAnamnesisFormId()" (selectionChange)="selectAnamnesisForm($event.value)">
          @for (form of anamnesisForms(); track form.id) {
            <mat-option [value]="form.id">{{ form.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="anamnesis-overlay__body">
        @if (anamnesisLoading()) {
          <mat-spinner [diameter]="32" class="anamnesis-overlay__spinner"></mat-spinner>
        } @else if (anamnesisRegistration(); as registration) {
          <app-form
            [form]="selectedAnamnesisForm()"
            [registration]="registration"
            [showDeleteButton]="false"
            [shadow]="false"
            [showRegisteredMetadata]="true"></app-form>
        } @else if (selectedAnamnesisFormId()) {
          <p class="anamnesis-overlay__hint">
            {{ 'epd.functions.careplan-nnn.add-row-dialog.no-form-found' | translate | capitalize }}
          </p>
        } @else {
          <p class="anamnesis-overlay__hint">
            {{ 'epd.functions.careplan-nnn.add-row-dialog.select-form-hint' | translate | capitalize }}
          </p>
        }
      </div>
    </section>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>{{ 'general.words.cancel' | translate | capitalize }}</button>
  <button mat-flat-button color="primary" [disabled]="!canSubmit()" [mat-dialog-close]="result()">
    {{ (isEdit ? 'general.actions.save' : 'general.actions.add') | translate | capitalize }}
  </button>
</mat-dialog-actions>
